window.addEventListener('load', function () {
   const footer = document.querySelector('.invisible-onload');
   if (footer) {
     footer.classList.remove('invisible-onload');
   //   footer.style.visibility = 'visible';
     footer.style.display = 'block';
   }
 });

// const BREAK_POINT_LG  = 990;
// let windowWidth  = window.innerWidth;

// import
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);
/* テストショップ用ID: 17186889695398
   ローカルID: 23296265945394 
   本番ID: 23295735660850   */

// main
// const sections = document.querySelectorAll("#shopify-section-template--23295735660850__image_banner_r337Cm, #shopify-section-template--23295735660850__image_banner_QXyJhW,#shopify-section-template--23295735660850__image_banner_tqcKqE,#shopify-section-template--23295735660850__image_banner_dVjX7N");
// sections.forEach((section) => {
//   const pin = section.querySelector(".banner");
//   const height = section.getBoundingClientRect().height;

//   gsap.set(pin, {
//     height: height,
//   });

//   ScrollTrigger.create({
//     trigger: section,
//     start: "top middle",
//     markers: false,
//     onEnter: () => {
//       gsap.set(pin, {
//         position: "fixed",
//         top: "auto",
//         bottom: 0,
//         left: 0,
//       });
//     },
//     onLeaveBack: () => {
//       gsap.set(pin, {
//         position: "absolute",
//         top: 0,
//         bottom: "auto",
//         left: 0,
//       });
//     },
//   });
// });

// const parallaxImage = () => {
//   if (!document.querySelectorAll('#shopify-section-template--23295735660850__image_banner_r337Cm,#shopify-section-template--23295735660850__image_banner_QXyJhW,#shopify-section-template--23295735660850__image_banner_tqcKqE,#shopify-section-template--23295735660850__image_banner_dVjX7N')) {
//     return false;
//   }
//   Array.from(document.querySelectorAll('#shopify-section-template--23295735660850__image_banner_r337Cm,#shopify-section-template--23295735660850__image_banner_QXyJhW,#shopify-section-template--23295735660850__image_banner_tqcKqE,#shopify-section-template--23295735660850__image_banner_dVjX7N')).forEach(item => {
//     let target = "";
//     let scale = "";
//     if( windowWidth < BREAK_POINT_LG ) {
//       target = item.querySelector('.banner__media:nth-of-type(2) img');
//       scale = 1.36;
//     } else{
//       target = item.querySelector('.banner__media:nth-of-type(1) img');
//       scale = 1.36;
//     };
    
//     const y = Number(item.getAttribute('data-y')) || -0.18;
//     const position = item.clientHeight * y;
    
//     gsap.to(target, {
//       y: position,
//       // scale: 1.2,
//       scrollTrigger: {
//         trigger: target,
//         start: 'top bottom',
//         end: 'bottom top',
//         scrub: 1,
//         onStart: () => {
//           gsap.set(target, { scale: scale });
//         },
//         onUpdate: () => {
//           gsap.set(target, { scale: scale });
//         }
//       }
//     });
//   });
// }
// parallaxImage();